module.exports = __webpack_public_path__ + "static/media/icon-baby-lock.7b00bb64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/icon-baby-lock.svg
// module id = 743
// module chunks = 0